<script setup lang="ts">
import { computed } from 'vue'

import { getAllCountries, getCountryName } from '@tix/common-utils'

import SelectField from './SelectField.vue'
import { useComputedInput } from './helpers'
import type { CountryInputProps } from './types'

defineOptions({ inheritAttrs: false })

const props = defineProps<CountryInputProps>()
const emit = defineEmits(['update:modelValue'])
const input = useComputedInput(props, emit)

const countries = getAllCountries().map((c) => ({
  value: c.iso2,
  label: c.country,
}))

/** Explicit props for SelectField so our options are always used; parent may pass options via attrs and override otherwise. */
const selectFieldProps = computed(() => ({
  id: props.id,
  label: props.label,
  placeholder: props.placeholder,
  disabled: props.disabled,
  readOnly: props.readOnly,
  tabindex: props.tabindex,
  type: 'select' as const,
  options: countries,
}))

const displayCountry = computed(() => {
  const value = input.value
  if (typeof value !== 'string' || !value.trim()) return null
  return {
    name: getCountryName(value),
    flag: value.toLowerCase(),
  }
})
</script>

<template>
  <div v-if="props.readOnly" class="display-country">
    <template v-if="displayCountry">
      <span :class="`fi fi-${displayCountry.flag}`"></span> {{ displayCountry.name }}
    </template>
  </div>
  <SelectField v-else v-bind="selectFieldProps" v-model="input" />
</template>
